import { style } from '@vanilla-extract/css';

export const publicationDetailsContainer = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  '@media': {
    'screen and (min-width: 640px)': {
      alignItems: 'start',
    },
  },
});
